import React, { useState } from "react";
import "./Navbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faAngleDown,
  faBars,
  faX,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";

const Menu = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleDropdown = (menu) => {
    setActiveDropdown((prev) => (prev === menu ? null : menu));
  };

  return (
    <>
      {/* --- Desktop Navbar --- */}

      {/* Menu */}
      <div className="menuContainer">
        <ul>
          {/* Home */}
          <li id="menuHome">
            <Link to={"/"}>
              <FontAwesomeIcon icon={faHome} className="menuIcon" />
            </Link>
          </li>

          {/* Attestation */}
          <li>
            <Link to={"/certificate-attestation-bangalore"}>Attestation</Link>
            <FontAwesomeIcon icon={faAngleDown} className="menuIcon" />
            <div className="menuDrop">
              <li>
                <NavHashLink
                  smooth
                  to={"/degree-certificate-attestation-bangalore"}
                >
                  Degree Certificate
                </NavHashLink>
              </li>
              <li>
                <NavHashLink
                  smooth
                  to={"/birth-certificate-attestation-bangalore"}
                >
                  Birth Certificate
                </NavHashLink>
              </li>
              <li>
                <NavHashLink
                  smooth
                  to={"/marriage-certificate-attestation-bangalore"}
                >
                  Marriage Certificate
                </NavHashLink>
              </li>
              <li>
                <NavHashLink
                  smooth
                  to={"/commercial-documents-attestation-bangalore"}
                >
                  Commercial Documents
                </NavHashLink>
              </li>
            </div>
          </li>

          {/* Apostille */}
          <li>
            <Link to={"/certificate-apostille-bangalore"}>Apostille</Link>
            <FontAwesomeIcon icon={faAngleDown} className="menuIcon" />
            <div className="menuDrop">
              <li>
                <NavHashLink
                  smooth
                  to={"/certificate-apostille-bangalore/#apoEduContainer"}
                >
                  Education Certificate
                </NavHashLink>
              </li>
              <li>
                <NavHashLink
                  smooth
                  to={"/certificate-apostille-bangalore/#apoNonEduContainer"}
                >
                  Non-Education Certificates
                </NavHashLink>
              </li>
              <li>
                <NavHashLink
                  smooth
                  to={"/birth-certificate-apostille-bangalore"}
                >
                  Birth Certificates
                </NavHashLink>
              </li>
              <li>
                <NavHashLink
                  smooth
                  to={"/marriage-certificate-apostille-bangalore"}
                >
                  Marriage Certificates
                </NavHashLink>
              </li>
            </div>
          </li>

          {/* State HRD */}
          <li>
            <Link to={"/state-hrd-home-department-attestation"}>State HRD</Link>
            <FontAwesomeIcon icon={faAngleDown} className="menuIcon" />
            <div className="menuDrop">
              <li>
                <Link to={"/karanataka-hrd-home-department-attestation"}>
                  Karnataka
                </Link>
              </li>
              <li>
                <Link to={"/tamilnadu-hrd-home-department-attestation"}>
                  Tamil Nadu
                </Link>
              </li>
              <li>
                <Link to={"/kerala-hrd-home-department-attestation"}>
                  Kerala
                </Link>
              </li>
              <li>
                <Link to={"/maharashtra-hrd-home-department-attestation"}>
                  Maharashtra
                </Link>
              </li>
              <li>
                <Link to={"/andhrapradesh-hrd-home-department-attestation"}>
                  Andhra Pradesh
                </Link>
              </li>
              <li>
                <Link to={"/telangana-hrd-home-department-attestation"}>
                  Telangana
                </Link>
              </li>
            </div>
          </li>

          {/* MOFA */}
          <li>
            <Link to={"/mofa-attestation-services"}>MOFA</Link>
            <FontAwesomeIcon icon={faAngleDown} className="menuIcon" />
            <div className="menuDrop">
              <li>
                <NavHashLink
                  smooth
                  to={"/mofa-attestation-services/#mofaCertIncorp"}
                >
                  Certificate Of Incorporation
                </NavHashLink>
              </li>
              <li>
                <NavHashLink
                  smooth
                  to={"/mofa-attestation-services/#memorandum"}
                >
                  Memorandum of Association
                </NavHashLink>
              </li>
              <li>
                <NavHashLink
                  smooth
                  to={"/mofa-attestation-services/#exportInvoice"}
                >
                  Export Invoice
                </NavHashLink>
              </li>
              <li>
                <NavHashLink
                  smooth
                  to={"/mofa-attestation-services/#packagingList"}
                >
                  Packaging list
                </NavHashLink>
              </li>
              <li>
                <NavHashLink
                  smooth
                  to={"/mofa-attestation-services/#certOfOrigin"}
                >
                  Certificate of Origin
                </NavHashLink>
              </li>
              <li>
                <NavHashLink
                  smooth
                  to={"/mofa-attestation-services/#chemAnalysis"}
                >
                  Chemical Analysis Report
                </NavHashLink>
              </li>
              <li>
                <NavHashLink
                  smooth
                  to={"/mofa-attestation-services/#phyAnalysis"}
                >
                  Physical Analysis Report
                </NavHashLink>
              </li>
              <li>
                <NavHashLink smooth to={"/mofa-attestation-services/#article"}>
                  Articles of Association
                </NavHashLink>
              </li>
            </div>
          </li>

          {/* PCC */}
          <li>
            <Link to={"/pcc-attestation-bangalore"}>PCC</Link>
            <FontAwesomeIcon icon={faAngleDown} className="menuIcon" />
            <div className="menuDrop">
              <li>
                <Link to="/oman-pcc-attestation-bangalore">Oman PCC</Link>
              </li>
              <li>
                <Link to="/kuwait-pcc-attestation-bangalore">Kuwait PCC</Link>
              </li>
              <li>
                <Link to="/saudi-pcc-attestation-bangalore">Saudi PCC</Link>
              </li>
              <li>
                <Link to="/qatar-pcc-attestation-bangalore">Qatar PCC</Link>
              </li>
              <li>
                <Link to="/uae-pcc-attestation-bangalore">UAE PCC</Link>
              </li>
            </div>
          </li>

          {/* Simple links */}
          <li>
            <Link to={"/mea-attestation-apostille-services"}>MEA</Link>
          </li>
          <li>
            <Link to={"/wes-attestation-bangalore"}>WES</Link>
          </li>
          <li>
            <Link to={"/translation-attestation-bangalore"}>Translation</Link>
          </li>
          <li>
            <Link to={"/contact-us"}>Contact Us</Link>
          </li>
        </ul>
      </div>

      {/* Hamburger for Mobile */}
      <div className="mainMenu" onClick={() => setSidebarOpen(true)}>
        <FontAwesomeIcon icon={faBars} className="hamIcon" />
      </div>

      {/* --- Mobile Sidebar --- */}
      <div className={`respMenu ${sidebarOpen ? "open" : ""}`}>
        <div className="respMenuScroll">
          {/* Top Row (Home + Close) */}
          <ul className="respSideBar-home">
            <h2>
              <Link onClick={() => setSidebarOpen(false)} to={"/"}>
                Home
              </Link>
            </h2>
            <h2 className="cross">
              <FontAwesomeIcon
                icon={faX}
                onClick={() => setSidebarOpen(false)}
                className="respIcon"
              />
            </h2>
          </ul>

          {/* Attestation */}
          <ul className="serviceDrop">
            <h2>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={"/certificate-attestation-bangalore"}
              >
                Attestation
              </Link>
              <FontAwesomeIcon
                onClick={() => toggleDropdown("attestation")}
                icon={faAngleDown}
                className="respDropIcon"
              />
            </h2>
            {activeDropdown === "attestation" && (
              <span className="respMenuSpan">
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/degree-certificate-attestation-bangalore"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Degree Certificate
                    </NavHashLink>
                  </h3>
                </li>
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/birth-certificate-attestation-bangalore"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Birth Certificate
                    </NavHashLink>
                  </h3>
                </li>
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/marriage-certificate-attestation-bangalore"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Marriage Certificate
                    </NavHashLink>
                  </h3>
                </li>
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/commercial-documents-attestation-bangalore"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Commercial Documents
                    </NavHashLink>
                  </h3>
                </li>
              </span>
            )}
          </ul>

          {/* Apostille */}
          <ul className="serviceDrop">
            <h2>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={"/certificate-apostille-bangalore"}
              >
                Apostille
              </Link>
              <FontAwesomeIcon
                onClick={() => toggleDropdown("apostille")}
                icon={faAngleDown}
                className="respDropIcon"
              />
            </h2>
            {activeDropdown === "apostille" && (
              <span className="respMenuSpan">
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/certificate-apostille-bangalore/#apoEduContainer"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Education Certificate
                    </NavHashLink>
                  </h3>
                </li>
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={
                        "/certificate-apostille-bangalore/#apoNonEduContainer"
                      }
                      onClick={() => setSidebarOpen(false)}
                    >
                      Non-Education Certificates
                    </NavHashLink>
                  </h3>
                </li>
                  <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={
                        "/birth-certificate-apostille-bangalore"
                      }
                      onClick={() => setSidebarOpen(false)}
                    >
                      Birth Certificates
                    </NavHashLink>
                  </h3>
                </li>
                  <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={
                        "/marriage-certificate-apostille-bangalore"
                      }
                      onClick={() => setSidebarOpen(false)}
                    >
                      Marriage Certificates
                    </NavHashLink>
                  </h3>
                </li>
              </span>
            )}
          </ul>

          {/* State HRD */}
          <ul className="serviceDrop">
            <h2>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={"/state-hrd-home-department-attestation"}
              >
                State HRD
              </Link>
              <FontAwesomeIcon
                onClick={() => toggleDropdown("hrd")}
                icon={faAngleDown}
                className="respDropIcon"
              />
            </h2>
            {activeDropdown === "hrd" && (
              <span className="respMenuSpan">
                <li>
                  <h3>
                    <Link
                      to={"/karanataka-hrd-home-department-attestation"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Karnataka
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link
                      to={"/tamilnadu-hrd-home-department-attestation"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Tamil Nadu
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link
                      to={"/kerala-hrd-home-department-attestation"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Kerala
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link
                      to={"/maharashtra-hrd-home-department-attestation"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Maharashtra
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link
                      to={"/andhrapradesh-hrd-home-department-attestation"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Andhra Pradesh
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link
                      to={"/telangana-hrd-home-department-attestation"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Telangana
                    </Link>
                  </h3>
                </li>
              </span>
            )}
          </ul>

          {/* MOFA */}
          <ul className="serviceDrop">
            <h2>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={"/mofa-attestation-services"}
              >
                MOFA
              </Link>
              <FontAwesomeIcon
                onClick={() => toggleDropdown("mofa")}
                icon={faAngleDown}
                className="respDropIcon"
              />
            </h2>
            {activeDropdown === "mofa" && (
              <span className="respMenuSpan">
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/mofa-attestation-services/#mofaCertIncorp"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Certificate Of Incorporation
                    </NavHashLink>
                  </h3>
                </li>
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/mofa-attestation-services/#memorandum"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Memorandum of Association
                    </NavHashLink>
                  </h3>
                </li>
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/mofa-attestation-services/#exportInvoice"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Export Invoice
                    </NavHashLink>
                  </h3>
                </li>
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/mofa-attestation-services/#packagingList"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Packaging list
                    </NavHashLink>
                  </h3>
                </li>
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/mofa-attestation-services/#certOfOrigin"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Certificate of Origin
                    </NavHashLink>
                  </h3>
                </li>
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/mofa-attestation-services/#chemAnalysis"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Chemical Analysis Report
                    </NavHashLink>
                  </h3>
                </li>
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/mofa-attestation-services/#phyAnalysis"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Physical Analysis Report
                    </NavHashLink>
                  </h3>
                </li>
                <li>
                  <h3>
                    <NavHashLink
                      smooth
                      to={"/mofa-attestation-services/#article"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Articles of Association
                    </NavHashLink>
                  </h3>
                </li>
              </span>
            )}
          </ul>

          {/* PCC */}
          <ul className="serviceDrop">
            <h2>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={"/pcc-attestation-bangalore"}
              >
                PCC
              </Link>
              <FontAwesomeIcon
                onClick={() => toggleDropdown("pcc")}
                icon={faAngleDown}
                className="respDropIcon"
              />
            </h2>
            {activeDropdown === "pcc" && (
              <span className="respMenuSpan">
                <li>
                  <h3>
                    <Link
                      to={"/oman-pcc-attestation-bangalore"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Oman PCC
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link
                      to={"/kuwait-pcc-attestation-bangalore"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Kuwait PCC
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link
                      to={"/saudi-pcc-attestation-bangalore"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Saudi PCC
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link
                      to={"/qatar-pcc-attestation-bangalore"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      Qatar PCC
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link
                      to={"/uae-pcc-attestation-bangalore"}
                      onClick={() => setSidebarOpen(false)}
                    >
                      UAE PCC
                    </Link>
                  </h3>
                </li>
              </span>
            )}
          </ul>

          {/* Simple Links */}
          <ul>
            <h2>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={"/mea-attestation-apostille-services"}
              >
                MEA
              </Link>
            </h2>
          </ul>
          <ul>
            <h2>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={"/wes-attestation-bangalore"}
              >
                WES
              </Link>
            </h2>
          </ul>
          <ul>
            <h2>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={"/translation-attestation-bangalore"}
              >
                Translation
              </Link>
            </h2>
          </ul>
          <ul>
            <h2>
              <Link onClick={() => setSidebarOpen(false)} to={"/contact-us"}>
                Contact Us
              </Link>
            </h2>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Menu;
